import React from 'react'
import ReactSlider, { ReactSliderProps } from 'react-slider'

import styles from './RangeSlider.module.scss'

type RangeSliderValue = number | readonly number[]

type RangeSliderProps<T extends RangeSliderValue> = {
  ariaLabel: ReactSliderProps<T>['ariaLabel']
  max: number
  min: number
  step?: number
  value: T
  onChange?: (value: T) => void
  onChangeComplete: (value: T) => void
}

/**
 * Revamp filter slider. A number renders one thumb (upper bound); a [lower, upper]
 * array renders two, and the selected segment moves to the middle track.
 *
 * Thumb and tracks are left to react-slider's own elements (styled via class
 * props) — it writes position `style` on every pointer move, and routing that
 * through ct-design `Container` would insert a stylesheet rule per move.
 */
const RangeSlider = <T extends RangeSliderValue>({
  ariaLabel,
  max,
  min,
  step = 1,
  value,
  onChange,
  onChangeComplete,
}: RangeSliderProps<T>) => {
  const className = Array.isArray(value) ? `${styles.slider} ${styles.sliderTwoWay}` : styles.slider

  return (
    <ReactSlider<T>
      ariaLabel={ariaLabel}
      className={className}
      max={max}
      min={min}
      step={step}
      thumbClassName={styles.thumb}
      // Global name: react-slider appends `-<index>` per segment, which a CSS module can't hash.
      trackClassName='filter-range-track'
      value={value}
      onAfterChange={onChangeComplete}
      onChange={onChange}
    />
  )
}

export default RangeSlider
